import styles from './FJAIImageList.module.less';
import FJMenuTab from '../../../components/FJMenuTab/FJMenuTab.jsx';
import FJSideModel from '../../../components/FJSideModel/FJSideModel.jsx';
import PropTypes from 'prop-types';
import { useRef, useState, useEffect } from 'react';
import FJSidePhotoListPanel from '../../../components/FJSidePhotoListPanel/FJSidePhotoListPanel.jsx';
import FJButton from '../../../components/FJButton/FJButton.jsx';
import FJConstant from '../../../../constants/FJConstant.js';

const FJAIImageList = props => {
    const {
        active,
        closeModal,
        list = [],
        position = { top: 148, left: 478 },

        itemClick,
    } = props;

    const menuTabList = useRef(list ? list.map(item => ({ text: item.title })) : []);
    const [curMenuIndex, setCurMenuIndex] = useState(0);
    const loadStatus = list[curMenuIndex]?.loadStatus;

    const sideModelRef = useRef(null);

    const _itemClick = info => {
        itemClick(info, curMenuIndex);
    };

    useEffect(() => {
        if (loadStatus === FJConstant.SUCCESS) {
            sideModelRef.current.resizeFit();
        }
    }, [loadStatus]);

    const onGenerateClick = () => {
        closeModal();
        list[curMenuIndex]?.onGenerateClick();
    };

    const renderBottom = () => {
        if (!list[curMenuIndex]) return null;

        const isShow = list[curMenuIndex].loadStatus === FJConstant.SUCCESS && list[curMenuIndex].imageList.length >= 1;

        if (!isShow) {
            return null;
        }

        return (
            <div className={styles.bottom}>
                <FJButton text='generate-now' type='gradient' className={styles.btn} onClick={onGenerateClick} />
            </div>
        );
    };

    return (
        <FJSideModel
            position={position}
            ref={sideModelRef}
            active={active}
            onClose={closeModal}
            className={styles.mask}
        >
            <div className={styles.content}>
                <FJMenuTab list={menuTabList.current} curIndex={curMenuIndex} onChange={setCurMenuIndex} />

                {list.map((item, index) => {
                    return (
                        <div style={{ display: curMenuIndex === index ? 'block' : 'none' }} key={index}>
                            <FJSidePhotoListPanel
                                list={item.imageList}
                                sizeList={item.sizeList}
                                status={item.loadStatus}
                                isShowBottom={false}
                                historyType={item.historyType}
                                scrollerClassName={styles.scroller}
                                onClickRetry={item.onRetry}
                                itemClick={_itemClick}
                            />
                        </div>
                    );
                })}
            </div>
            {renderBottom()}
        </FJSideModel>
    );
};

FJAIImageList.propTypes = {
    active: PropTypes.bool,
    closeModal: PropTypes.func,
    list: PropTypes.array,
    itemClick: PropTypes.func,
};
export default FJAIImageList;
